export const VERIFY_TOKEN = '/verify-token';
export const GET_USER_ID_BY_COGNITO_ID = '/cognito-users';
export const GET_USER_TYPES = '/user-types';
export const GET_SUPPORT = '/support';
export const GET_DEPARTMENTS = '/departments';
export const GET_SCHOOLS = '/schools';
export const GET_IP_STATUSES = '/ip-status';
export const POST_INVITE_OTHERS = '/invite-user';
export const POST_REQUEST_INVITE = '/request-invitation';
export const USERS = '/users';
// NEED_TO_FIX the below api
export const IDEA_OWNERS = '/idea-owners';
export const IDEAS = '/ideas';
export const UPDATE_PROFILE = '/users';
export const IDEAS_COUNT = '/ideas/count';
export const GET_RECOMMENDED_IDEAS = 'recommendations/ideas'; // need to roll back once api is fixed --'/recommendations/ideas';
